import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export type TAmountFormFieldsName = {
    // Transaction Amount information
    transactionAmount: string;
    transactionCurrencyCode: string;
    settlementAmount: string;
    currencyCodePayment: string;
    invoiceAmount: string;
    currencyCodeInvoice: string;
    acquirerSettlementAmount: string;
    currencyCodeSettlementAcquirer: string;
    issuerSettlementAmount: string;
    currencyCodeIssuerSettlement: string;
    cashBackAmount: string;

    // Taux Conversion Monnaie information
    settlementConversionRate: string;
    issuerSettlementConversionRate: string;
    acquirerSettlementConversionRate: string;
    conversionRateInvoicePayment: string;

    // CPS information
    transactionIdentifier: string;
    requestServicePayment: string;
    validationCode: string;
    indicatorCharacteristicAuthorization: string;

    [name: string]: string;
}

export interface IAmountFormMeta {
    // Transaction Amount information
    transactionAmount: FormInputMeta;
    transactionCurrencyCode: FormInputMeta;
    settlementAmount: FormInputMeta;
    currencyCodePayment: FormInputMeta;
    invoiceAmount: FormInputMeta;
    currencyCodeInvoice: FormInputMeta;
    acquirerSettlementAmount: FormInputMeta;
    currencyCodeSettlementAcquirer: FormInputMeta;
    issuerSettlementAmount: FormInputMeta;
    currencyCodeIssuerSettlement: FormInputMeta;
    cashBackAmount: FormInputMeta;

    // Taux Conversion Monnaie information
    settlementConversionRate: FormInputMeta;
    issuerSettlementConversionRate: FormInputMeta;
    acquirerSettlementConversionRate: FormInputMeta;
    conversionRateInvoicePayment: FormInputMeta;

    // CPS information
    transactionIdentifier: FormInputMeta;
    requestServicePayment: FormInputMeta;
    validationCode: FormInputMeta;
    indicatorCharacteristicAuthorization: FormInputMeta;

    schema: any;
}

const amountFormMeta = {} as IAmountFormMeta;

amountFormMeta.transactionAmount = {
  name: "transactionAmount",
  type: "text",
  label: "Montant Transaction",
  placeholder: "",
  validation: yup.string(),
};

amountFormMeta.transactionCurrencyCode = {
  name: "transactionCurrencyCode",
  type: "text",
  label: "Code Monnaie Transaction",
  placeholder: "",
  validation: yup.string(),
};

amountFormMeta.settlementAmount = {
  name: "settlementAmount",
  type: "text",
  label: "Montant Règlement",
  placeholder: "",
  validation: yup.string(),
};

amountFormMeta.currencyCodePayment = {
  name: "currencyCodePayment",
  type: "text",
  label: "Code Monnaie Règlement",
  placeholder: "",
  validation: yup.string(),
};

amountFormMeta.invoiceAmount = {
  name: "invoiceAmount",
  type: "text",
  label: "Montant Facture",
  placeholder: "",
  validation: yup.string(),
};

amountFormMeta.currencyCodeInvoice = {
  name: "currencyCodeInvoice",
  type: "text",
  label: "Code Monnaie Facture",
  placeholder: "",
  validation: yup.string(),
};

amountFormMeta.acquirerSettlementAmount = {
  name: "acquirerSettlementAmount",
  type: "text",
  label: "Montant Règlement Acquéreur",
  placeholder: "",
  validation: yup.string(),
};

amountFormMeta.currencyCodeSettlementAcquirer = {
  name: "currencyCodeSettlementAcquirer",
  type: "text",
  label: "Code Monnaie Règlement Acquéreur",
  placeholder: "",
  validation: yup.string(),
};

amountFormMeta.issuerSettlementAmount = {
  name: "issuerSettlementAmount",
  type: "text",
  label: "Montant Règlement Emetteur",
  placeholder: "",
  validation: yup.string(),
};

amountFormMeta.currencyCodeIssuerSettlement = {
  name: "currencyCodeIssuerSettlement",
  type: "text",
  label: "Code Monnaie Règlement Emetteur",
  placeholder: "",
  validation: yup.string(),
};

amountFormMeta.cashBackAmount = {
    name: "cashBackAmount",
    type: "text",
    label: "Montant Cashback",
    placeholder: "",
    validation: yup.string(),
};

// Taux Conversion Monnaie
amountFormMeta.settlementConversionRate = {
    name: "settlementConversionRate",
    type: "text",
    label: "Taux Conversion Règlement",
    placeholder: "",
    validation: yup.string(),
};

amountFormMeta.issuerSettlementConversionRate = {
    name: "issuerSettlementConversionRate",
    type: "text",
    label: "Taux Conversion Règlement Emetteur",
    placeholder: "",
    validation: yup.string(),
};

amountFormMeta.acquirerSettlementConversionRate = {
    name: "acquirerSettlementConversionRate",
    type: "text",
    label: "Taux Conversion Règlement Acquéreur",
    placeholder: "",
    validation: yup.string(),
};

amountFormMeta.conversionRateInvoicePayment = {
    name: "conversionRateInvoicePayment",
    type: "text",
    label: "Taux Conversion Facture Règlement",
    placeholder: "",
    validation: yup.string(),
};

// CPS information
amountFormMeta.transactionIdentifier = {
    name: "transactionIdentifier",
    type: "text",
    label: "Identifiant Transaction",
    placeholder: "",
    validation: yup.string(),
};
  
amountFormMeta.requestServicePayment = {
    name: "requestServicePayment",
    type: "text",
    label: "Demande Service Paiement",
    placeholder: "",
    validation: yup.string(),
};
  
amountFormMeta.validationCode = {
    name: "validationCode",
    type: "text",
    label: "Code Validation",
    placeholder: "",
    validation: yup.string(),
};
  
amountFormMeta.indicatorCharacteristicAuthorization = {
    name: "indicatorCharacteristicAuthorization",
    type: "text",
    label: "Indicateur Caractéristique Autorisation ",
    placeholder: "",
    validation: yup.string(),
};
  
  
amountFormMeta.schema = yup.object().shape(getValidationSchema(amountFormMeta));

export default amountFormMeta;